import { render, staticRenderFns } from "./protocol.vue?vue&type=template&id=b7d4e52c&scoped=true"
import script from "./protocol.vue?vue&type=script&lang=ts"
export * from "./protocol.vue?vue&type=script&lang=ts"
import style0 from "./protocol.vue?vue&type=style&index=0&id=b7d4e52c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d4e52c",
  null
  
)

export default component.exports